import { gql } from 'apollo-angular';
import ID from '../../../../types/id';
import DocumentVersion from '../../../../interfaces/document-version';
import DocumentSubtypeDueDate from '../../../../interfaces/document-subtype-due-date';

type GetVersionsRequest = {
  document_id: ID;
};
type GetVersionsResponse = {
  versionsByDocId: DocumentVersion[];
  documentSubtypeDueDates: DocumentSubtypeDueDate[];
};

export const GET_VERSIONS = gql<GetVersionsResponse, GetVersionsRequest>`
  query getVersions($document_id: ID!) {
    documentSubtypeDueDates(document_id: $document_id) {
      id
      doc_subtype_id
      document_id
      due_date
    }
    versionsByDocId(
      document_id: $document_id
      order: [
        { column: VERSION, order: DESC }
        { column: STATUS_DATE, order: DESC }
      ]
    ) {
      id
      document_id
      doc_status_id
      status_date
      doc_subtype_id
      version
      user {
        id
        person {
          id
          name
        }
      }
      documentVersionNotes {
        id
        document_version_id
        note_text
        user {
          id
          person {
            id
            name
          }
        }
        created
        modified
      }
    }
  }
`;

export type CreateVersionInput = {
  doc_status_id: ID;
  doc_subtype_id: ID;
  document_id: ID;
  version: number;
  status_date: string;
  user_id: ID;
};
type CreateVersionResult = {
  createDocVersion: DocumentVersion;
};
type CreateVersionVariables = {
  input: CreateVersionInput;
};
export const CREATE_VERSION = gql<CreateVersionResult, CreateVersionVariables>`
  mutation createDocVersion($input: CreateDocVersionInput!) {
    createDocVersion(input: $input) {
      id
      document_id
    }
  }
`;

export type UpdateVersionInput = {
  status_date: string;
};
type UpdateVersionResult = {
  updateDocVersion: DocumentVersion;
};
type UpdateVersionVariables = {
  id: ID;
  input: UpdateVersionInput;
};

export const UPDATE_VERSION = gql<UpdateVersionResult, UpdateVersionVariables>`
  mutation updateDocVersion($id: ID!, $input: UpdateDocVersionInput!) {
    updateDocVersion(id: $id, input: $input) {
      id
      document_id
    }
  }
`;

type DeleteVersionResults = {
  deleteDocumentVersions: DocumentVersion[];
};
type DeleteVersionsVariables = {
  document_version_id:ID
  type: string
};
export const DELETE_VERSIONS = gql<
  DeleteVersionResults,
  DeleteVersionsVariables
>`
  mutation deleteDocumentVersions($document_version_id: ID!, $type: String!) {
    deleteDocumentVersions(document_version_id: $document_version_id, type:$type) {
      id
    }
  }
`;
